// RudrakshaHealing.jsx
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from "react-router-dom";

export default function RudrakshaHealing() {

  // const RudrakshaHealingData = [
  //   {
  //     id:1,
  //   },
  //   {
  //     id:2,
  //   },
  //   {
  //     id:3,
  //   },
  // ]
  return (
    <section className="space-top">
      <div className="container">
        {/* Section Title */}
        <h2 className="font-semibold text-lora">
          Rudraksha Healing: Spiritual Wellness & Protection
        </h2>
        <p className="text-dark mb-[36px]">
          Discover the transformative potential of Rudraksha, promoting harmony
          and well-being in your life.
        </p>

        {/* Cards Row */}
        <div className="row g-4">
          {/* Card 1 */}
          <div className="col-12 col-md-4">
            <div className=" border-0 bg-[#faf6e6]  rounded-3 h-100">
              <h5
                className="p-3 font-semibold text-white text-lora lg:text-[24px]"
                style={{ backgroundColor: "#cda202", borderRadius: "0.5rem 0.5rem 0 0" }}
              >
                Balance Energies
              </h5>
              <div className="p-3 bg-[#faf6e6] flex flex-col justify-between  ">
                <p className="text-dark">
                  Ancient sacred beads used to balance energies and promote
                  profound mental peace.
                </p>
                <div> 
                    <NavLink to='/enroll' className=" second-btn" style={{border:'1px solid #cda202'}}>Email Now</NavLink>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-12 col-md-4">
            <div className=" border-0 bg-[#faf6e6]  rounded-3 h-100">
              <h5
                className="p-3 font-semibold text-white text-lora lg:text-[24px]"
                style={{ backgroundColor: "#cda202", borderRadius: "0.5rem 0.5rem 0 0" }}
              >
                Customized Recommendations
              </h5>
              <div className="p-3  bg-[#faf6e6] flex flex-col justify-between ">
                <p className="text-dark">
                  Based on individual astrological profiles for optimal spiritual
                  benefits.
                </p>
                <div> 
                    <NavLink to='/enroll' className=" second-btn" style={{border:'1px solid #cda202'}}>Email Now</NavLink>
                </div>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-12 col-md-4">
            <div className="  border-0 bg-[#faf6e6] rounded-3 h-100">
              <h5
                className="font-semibold p-3 text-white text-lora lg:text-[24px]"
                style={{ backgroundColor: "#cda202", borderRadius: "0.5rem 0.5rem 0 0" }}
              >
                Healing Powers
              </h5>
              <div className="p-3 bg-[#faf6e6] flex flex-col justify-between ">
                <p className="text-dark">
                  Gain insights into the profound spiritual benefits and healing
                  powers of Rudraksha.
                </p>
                <div> 
                    <NavLink to='/enroll' className=" second-btn" style={{border:'1px solid #cda202'}}>Email Now</NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
